<template>
  <div class="intent-item z-border-red" style="padding: 10px 15px 10px;">
    <form>
      <v-layout wrap>
        <v-flex xs12 class="text-xs-right">
          <span style="display: inline-block;vertical-align: top;">
            <v-btn color="primary" outline @click="showSelectPost = true">
              <template v-if="!auctionPostidlist">{{ $t('select_post') }}</template>
              <template v-else>
                <div>{{ $t('selected(1)') }}</div>
                <!-- <div>{{postdata.name | truncate(15)}}</div> -->
              </template>
              <v-icon class="ml-1">edit</v-icon>
            </v-btn>

            <intent-select-post
              v-if="showSelectPost"
              :singleselect="true"
              v-model="auctionPostidlist"
              :show="showSelectPost"
              :postdata.sync="postdata"
              @close="
                showSelectPost = false
                errorPost = false
              "
            ></intent-select-post>
          </span>
        </v-flex>
        <v-flex xs12>
          <div class="form-control pa-1 mt-1" :class="{ 'has-error': errors.has(`auction_title`) }">
            <label>{{ $t('auction_name') }} *</label>
            <input
              :data-vv-as="$t('auction_name')"
              v-model="auctionItem.auction_title"
              :name="`auction_title`"
              class="form-control mr-3"
              type="text"
              v-validate="'required'"
              maxlength="50"
            />
            <span class="text-error" v-if="errors.has(`auction_title`)">{{
              errors.first(`auction_title`)
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has(`bank_account_name`) }">
            <label>{{ $t('bank_account_name') }} *</label>
            <input
              :data-vv-as="$t('bank_account_name')"
              v-model="auctionItem.bank_account_name"
              :name="`bank_account_name`"
              class="form-control mr-3"
              type="text"
              v-validate="'required'"
              maxlength="100"
            />
            <span class="text-error" v-if="errors.has(`bank_account_name`)">{{
              errors.first(`bank_account_name`)
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div
            class="form-control pa-1"
            :class="{ 'has-error': errors.has(`bank_account_number`) }"
          >
            <label>{{ $t('bank_account_number') }} *</label>
            <input
              :data-vv-as="$t('bank_account_number')"
              v-model="auctionItem.bank_account_number"
              :name="`bank_account_number`"
              class="form-control mr-3"
              type="text"
              v-validate="'required|numeric'"
              maxlength="20"
            />
            <span class="text-error" v-if="errors.has(`bank_account_number`)">{{
              errors.first(`bank_account_number`)
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has(`bank_name`) }">
            <label>{{ $t('bank_name') }} *</label>
            <input
              :data-vv-as="$t('bank_name')"
              v-model="auctionItem.bank_name"
              :name="`bank_name`"
              class="form-control mr-3"
              type="text"
              v-validate="'required'"
              maxlength="100"
            />
            <span class="text-error" v-if="errors.has(`bank_name`)">{{
              errors.first(`bank_name`)
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has(`shipping_cost`) }">
            <label>{{ $t('shipping_fee') }} *</label>
            <input
              :data-vv-as="$t('shipping_fee')"
              v-model="auctionItem.shipping_cost"
              :name="`shipping_cost`"
              class="form-control mr-3"
              type="text"
              v-validate="'required|numeric'"
              maxlength="20"
            />
            <span class="text-error" v-if="errors.has(`shipping_cost`)">{{
              errors.first(`shipping_cost`)
            }}</span>
          </div>
        </v-flex>
      </v-layout>

      <h3>{{ $t('products') }}</h3>
      <div class="my-2">
        <toggle-button
          class="mt-2 mb-2"
          :value="allProductToggle"
          @change="allProductToggle = !allProductToggle"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
        <span class="ml-2">{{ $t('enable_auction_for_all_products') }}</span>
      </div>
      <div v-if="allProductToggle" class="my-2">
        <span class="ml-2">{{ $t('end_of_auction') }}</span>
        <v-layout wrap>
          <v-flex xs6 class="form-control" :class="{ 'has-error': errors.has('enddate') }">
            <v-menu
              :key="`endDate_${timestamp}`"
              ref="openEndDate"
              v-model="openModalDate"
              :close-on-content-click="false"
              full-width
              max-width="290px"
              color="primary"
            >
              <template v-slot:activator="{ on }">
                <input
                  type="text"
                  style="margin: 4px 0px;"
                  :placeholder="$t('Date')"
                  readonly
                  v-model="endDate"
                  v-on="on"
                  clearable
                  small
                  class="form-control browser-default"
                  v-validate="'required'"
                  :name="`endDate_`"
                  :data-vv-as="$t('วันที่')"
                />
              </template>
              <v-date-picker
                :allowed-dates="disablePastDates"
                color="primary"
                v-model="endDate"
                @input="
                  setEndtime()
                  openModalDate = false
                "
              ></v-date-picker>
            </v-menu>
            <span class="text-error" v-if="errors.has(`enddate`)">{{
              errors.first(`enddate`)
            }}</span>
          </v-flex>

          <v-flex xs6 class="pl-1 form-control" :class="{ 'has-error': errors.has('endTime') }">
            <time-picker
              class="mt-1 form-control browser-default"
              :name="`endTime`"
              :data-vv-as="$t('time')"
              :key="`setendtime_${timestamp}`"
              v-model="endTime"
              full-width
              format="HH:mm"
              :placeholder="$t('time')"
              :hide-clear-button="true"
              @input="setEndtime"
              v-validate="'required'"
            ></time-picker>
            <span class="text-error" v-if="errors.has(`endTime`)">{{
              errors.first(`endTime`)
            }}</span>
          </v-flex>
        </v-layout>
      </div>

      <template>
        <template v-for="(product, index) in products">
          <product-form
            @arrayProductRemove="arrayProductRemove(product.id)"
            :key="`product_${timestamp}_${index}`"
            :allProductToggle="allProductToggle"
            v-model="products[index]"
            :index="index"
            :errorTime.sync="errorTime"
          >
          </product-form>
        </template>
      </template>
      <div style="margin-bottom: 10px;" @click="addProducts()">
        <a href="javascript:void(0);">
          <div class="add-conversation text-xs-center">
            <i class="fa fa-plus middle"></i>
            {{ $t('add_product') }}
          </div>
        </a>
      </div>
      <div class="text-xs-center">
        <div>
          <div style="color: red; font-size: 0.9em;" v-if="errorProducts">
            {{ $t('please_add_product') }}
          </div>
          <div style="color: red; font-size: 0.9em;" v-if="errorPost">
            {{ $t('please_select_post') }}
          </div>
          <div style="color: red; font-size: 0.9em;" v-if="errorTime">
            {{ $t('please_specify_a_time') }}
          </div>
        </div>

        <v-btn outline :loading="loading" color="grey" @click="$emit('update:isShow', false)">{{
          $t('back')
        }}</v-btn>
        <v-btn outline :loading="loading" color="grey" @click="submitAuction(false)">{{
          $t('save_draft')
        }}</v-btn>
        <v-btn depressed :loading="loading" color="primary" @click="submitAuction(true)">{{
          $t('start_auction')
        }}</v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import TimePicker from '@/components/elements/TimePicker.vue'
import IntentSelectPost from '@/components/view/live/IntentSelectPost.vue'
import ProductForm from '@/components/view/liveAuction/ProductForm.vue'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import api from '@/api'

export default {
  props: {
    value: {
      default: null
    },
    isEdit: {
      default: false
    },
    isShow: {
      default: false
    }
  },
  components: {
    ToggleButton,
    TimePicker,
    IntentSelectPost,
    ProductForm
  },
  data: function() {
    return {
      endDate: null,
      endTime: { HH: '00', mm: '00' },
      setDateTime: null,
      auctionItem: this.value,
      products: this.value.product_data || [],
      openModalDate: false,
      allProductToggle: false,
      showSelectPost: false,
      postdata: { name: '' },
      auctionPostidlist: null,
      timestamp: dayjs().format('x'),
      errorProducts: false,
      errorPost: false,
      errorTime: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  provide() {
    return { parentValidator: this.$validator }
  },
  mounted() {
    const vm = this
    vm.endDate = vm.getFormatDate(dayjs(), 'YYYY-MM-DD')
    if (vm.auctionItem && vm.auctionItem.postidlist) {
      vm.postdata = JSON.parse(vm.auctionItem.postidlist)
      vm.auctionPostidlist = vm.postdata.id
    }
    if (
      vm.products.length !== 0 &&
      !vm.products.some(item => item.end_at !== vm.products[0].end_at)
    ) {
      vm.allProductToggle = true
      if (vm.products[0].end_at) {
        vm.endDate = vm.getFormatDate(vm.products[0].end_at, 'YYYY-MM-DD')
        vm.endTime = {
          HH: vm.getFormatDate(vm.products[0].end_at, 'HH'),
          mm: vm.getFormatDate(vm.products[0].end_at, 'mm')
        }
      }
      vm.timestamp = dayjs().format('x')
    }
  },
  methods: {
    disablePastDates(val) {
      return val >= new Date().toISOString().substr(0, 10)
    },
    setEndtime() {
      const vm = this
      vm.errorTime = false
      vm.setDateTime = dayjs(
        `${vm.endDate || vm.getFormatDate(dayjs(), 'YYYY-MM-DD')} ${
          vm.endTime ? vm.endTime.HH || '00' : '00'
        }:${vm.endTime ? vm.endTime.mm || '00' : '00'}`
      ).format()
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    },
    arrayProductRemove(itemId) {
      const vm = this
      vm.products = vm.products.filter(item => {
        return item.id !== itemId
      })
      vm.timestamp = dayjs().format('x')
    },

    deletePhoto(index, oindex) {
      const vm = this
      vm.$set(vm.stock[index][oindex], 7, null)
    },
    async submitAuction(isStart) {
      const vm = this
      const checkTime = vm.products.map(item => {
        return (
          (!vm.allProductToggle && new Date(item.end_at) > dayjs(new Date())) ||
          (vm.allProductToggle && new Date(vm.setDateTime) > dayjs(new Date()))
        )
      })
      let result = await vm.$validator.validateAll()
      if (vm.products.length === 0) {
        vm.errorProducts = true
      }
      if (vm.postdata.name === '' && isStart) {
        vm.errorPost = true
      }
      if (checkTime.includes(false)) {
        vm.errorTime = true
      }
      if (
        (result && !isStart && vm.products.length !== 0 && !checkTime.includes(false)) ||
        (result &&
          isStart &&
          vm.products.length !== 0 &&
          !checkTime.includes(false) &&
          vm.postdata.name !== '')
      ) {
        let data = {
          pageid: vm.selectedBot.pageid,
          body: {
            auction_title: vm.auctionItem.auction_title,
            shipping_cost: parseInt(vm.auctionItem.shipping_cost), // default 0
            postidlist: JSON.stringify(vm.postdata),
            auction_status: isStart ? 'active' : 'draft', // required ["active", "draft"]
            bank_account_number: vm.auctionItem.bank_account_number,
            bank_account_name: vm.auctionItem.bank_account_name,
            bank_name: vm.auctionItem.bank_name,
            product_data: vm.products.map(el => {
              return {
                product_title: el.product_title,
                product_image_url: el.product_image_url,
                q_type: el.q_type,
                q_val: `includes(${el.q_val})`,
                start_price: parseInt(el.start_price),
                minimum_bid: parseInt(el.minimum_bid),
                start_at: el.start_at,
                end_at: vm.allProductToggle ? vm.setDateTime : el.end_at,
                schedule_is_active: el.schedule_is_active,
                schedule_notify_max_bid_within_seconds: el.schedule_notify_max_bid_within_seconds
              }
            })
          }
        }
        if (isStart) {
          const vm = this
          let result = await vm.$swal.fire({
            title: vm.$t('do_you_want_to_start_auction', {
              name: vm.auctionItem.auction_title
            }),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          if (result.value) {
            if (vm.isEdit) {
              data.auctionid = vm.auctionItem.id
              vm.editAuction(data, isStart)
            } else {
              vm.saveAuction(data, isStart)
            }
          }
        } else {
          if (vm.isEdit) {
            data.auctionid = vm.auctionItem.id
            vm.editAuction(data, isStart)
          } else {
            vm.saveAuction(data, isStart)
          }
        }
      }
    },
    addProducts() {
      const vm = this
      vm.products.push({
        id: new Date(),
        product_title: null, // require
        product_image_url: null,
        q_type: 'text', // require
        q_val: 'includes()', // require
        start_price: null, // default 0
        minimum_bid: null, // default 0
        start_at: dayjs(), // yyyy-mm-dd HH:mm:ss
        end_at: vm.allProductToggle ? vm.setDateTime : vm.getFormatDate(dayjs(), 'YYYY-MM-DD'), // yyyy-mm-dd HH:mm:ss
        schedule_is_active: false,
        schedule_notify_max_bid_within_seconds: 0
      })
      vm.errorProducts = false
    },
    async editAuction(data, isStart) {
      const vm = this
      vm.loading = true
      try {
        let response = await api.editLiveAuction(data)
        if (response.success && response.result) {
          if (isStart) {
            vm.$emit('currentViewDashBoard', 'DashboardAuction')
            vm.$emit('setAuctionId', response.result.id)
            vm.successNoti(
              `${vm.$t('the_auction')} ${data.body.auction_title} ${vm.$t('has_started')}`
            )
          } else {
            vm.successNoti(
              `${vm.$t('the_auction')} ${data.body.auction_title} ${vm.$t('edit_the_auction_of')}`
            )
          }
        } else {
          vm.errorNoti()
        }
      } catch (error) {
        vm.errorNoti()
      }
      vm.loading = false
    },
    async saveAuction(data, isStart) {
      const vm = this
      vm.loading = true
      try {
        let response = await api.createLiveAuction(data)
        if (response.success && response.result) {
          if (isStart) {
            vm.$emit('currentViewDashBoard', 'DashboardAuction')
            vm.$emit('setAuctionId', response.result.id)
            vm.successNoti(
              `${vm.$t('the_auction')} ${data.body.auction_title} ${vm.$t('has_started')}`
            )
          } else {
            vm.successNoti(`${vm.$t('the_auction')} ${data.body.auction_title} ถูกเพิ่มแล้ว`)
          }
        } else {
          vm.errorNoti()
        }
      } catch (error) {
        vm.errorNoti()
      }
      vm.loading = false
    },
    successNoti(title) {
      const vm = this
      vm.$emit('getLiveAuction')
      vm.$swal.fire({
        title: vm.$t('Successfully'),
        text: title,
        type: 'success'
      })
      vm.$emit('update:isShow', false)
    },
    errorNoti() {
      const vm = this
      vm.$swal.fire({
        title: vm.$t('Unsuccessful'),
        text: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง',
        type: 'error'
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/liveAuction/AuctionForm.vue